/**
 * AureNovel 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors } from '@/config/brands'

export const aurenovelPaymentConfig: BrandPaymentConfig = {
  brand: 'aurenovel',

  // 充值页面配置
  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/aurenovel/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/aurenovel/member_subscribe_bg.webp',
      memberSubscribeBg: '/images/aurenovel/member_subscribe_bg.webp',
      vipIcon: '/images/aurenovel/vip-icon.png',
      vipDiscountIcon: '/images/aurenovel/vip-icon.png',
      discountBg: '/images/aurenovel/member_subscribe_bg.webp',
      showVipIcon: true,
    },
    colors: {
      redGradient: 'linear-gradient(90deg, #FFD666 0%, #FFB300 100%)',
      purpleTextGradient: 'linear-gradient(180deg, #FFD666 0%, #FFF0BF 70%, #FFF8E8 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
    },
  },

  // 阅读器弹窗配置
  chapter: {
    texts: chapterCommonTexts,
    colors: {
      coinsGradient: 'linear-gradient(180deg, #FFB300, #ffffff)',
      coinsPopupText1: '#FFFFFF',
      coinsPopupText2: '#FFB300',
      coinsPopupText3: '#65686F',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#FFF8E8',
      subscribeActiveBg: '#F3F5FA',
      purpleTextGradient: 'linear-gradient(180deg, #FFD666 0%, #FFF0BF 70%, #FFF8E8 100%)',
      pinkGradient: 'linear-gradient(90deg, #FFD666 0%, #FFB300 100%)',
      memberSubscribeBg: '/images/aurenovel/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}
